import { Classes, Styles } from "jss";
import { createUseStyles } from "react-jss";
import { ThemeItem } from "../../../../theme";
import { SubMenuItemsProps } from ".";

export type SubMenuItemsClassNames =
  | "servicesMenuBox"
  | "serviceMenuItemContainer"
  | "serviceMenuItemText"
  | "openedMenu"
  | "serviceMenuItemBox"
  | "serviceMenuItemLink";

export type SubMenuItemsClasses = Classes<SubMenuItemsClassNames>;
export type SubMenuItemsStyles = Styles<SubMenuItemsClassNames>;
export type SubMenuItemsStylesProps = SubMenuItemsProps;

const getStyles: (theme: ThemeItem) => SubMenuItemsStyles = (
  theme: ThemeItem
) => ({
  serviceMenuItemBox: { display: "flex", flexWrap: "wrap" },
  serviceMenuItemLink: { width: "50%" },
  servicesMenuBox: {
    display: "none",
    background: "white",
    borderRadius: 6,
    boxShadow: "0px 2px 4px #ccc",
    padding: 10,
    position: "absolute",
    left: 90,
    top: 14,
  },
  serviceMenuItemContainer: {
    display: "flex",
    alignItems: "center",
    padding: [8, 40],
    height: 28,
    borderRadius: 6,
    cursor: "pointer",
    transition: ".2s all",
    "&:hover": {
      background: "rgb(251 131 85 / 15%)",
    },
  },
  serviceMenuItemText: {
    fontWeight: 200,
    color: "#25262c",
    fontSize: 13,
    marginLeft: 8,
  },
  openedMenu: {
    display: "flex !important",
  },
});

const useSubMenuItemsStyles: (
  data?: SubMenuItemsStylesProps
) => SubMenuItemsClasses = createUseStyles<ThemeItem, SubMenuItemsClassNames>(
  getStyles
);

export default useSubMenuItemsStyles;
